import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import styles from './PostSelectRole.module.scss';

export default function ContinueButton({ handleNext }) {
  return (
    <div className={styles.continueButtonContainer}>
      <Button
        className={styles.continueButton}
        bsStyle="success"
        onClick={handleNext}
      >
        Continue with email
      </Button>
    </div>
  );
}
